import React from "react";

export const NotificationSetting = () => {
  return <div>NotificationSetting</div>;
};

export default NotificationSetting;
